import { AgeCategory, ContractCategory } from '../../types/categories';


export const staticTeamKeys: string[] = [
  'masterTeam',
  'shadowTeam',
  'ownTeam',
];


export const ageCategories: AgeCategory[] = [
  'U21',
  'U25',
  'U29',
  '29+',
];


export const contractCategories: ContractCategory[] = [
  'U1',
  'U2',
  'U3',
  '3+',
];
